<template>
  <div class="mt-5">
    <form @submit.prevent="userCreate">

      <h3>User Create</h3>

      <div class="form-group">
        <label>Name</label>
        <input type="text" class="form-control form-control-lg" v-model="name"/>
      </div>

      <div class="form-group">
        <label>Email</label>
        <input type="text" class="form-control form-control-lg" v-model="email"/>
      </div>

      <div class="form-group">
        <label>Password</label>
        <input type="password" class="form-control form-control-lg" v-model="password"/>
      </div>

      <button type="submit" class="btn btn-dark btn-lg btn-block mt-2">Create</button>

    </form>
  </div>
</template>

<script>
import axios from "axios";
import tokenRefresh from "@/utils/tokenRefresh";
import statusCheck from "@/utils/statusCheck";

export default {
  name: "UserCreate.vue",
  data() {
    return {
      name: '',
      email: '',
      password: '',
    }
  },
  methods: {
    userCreate: function () {
      const {name, email, password} = this;
      axios.post(process.env.VUE_APP_CRAWLING_URL + "/api/user/create", {name, email, password})
          .then((response) => {
                if (response.status === 201) {
                  tokenRefresh();
                  this.$router.push({name: "users"});
                }
              }
          )
          .catch((error) => {
                statusCheck(error.response.status);
              }
          )
    }
  }
}
</script>

<style scoped>

</style>